import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification, isMobile } from "../../../../helpers";
import { Spin, Row, Col, Switch, notification as Notification } from "antd";

class Settings extends Component {

    constructor(props) {
        super(props);

        this.endpoint = { keyOne: "account" };
        this.state = {
            form: {},
            loadings: {
                submit: false,
                data: false,
                proxyuser: false,
                proxyusersubmit: false,
                search: false
            },
            isShowModal: false,
            values: {
                proxyUsers: []
            }
        };
        this.proxyUserFormRef = React.createRef();

    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();

    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint
        })).then(response => {
            loadings.data = false;
            this.setState({
                form: response, loadings
            });
        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

            })
    }

    fetch = (field, value) => {

        let { loadings, form } = this.state;

        var param = {};
        var method = "updateData";
        loadings.submit = true;
        form[field] = value
        this.setState({ loadings, form });

        param[field] = value;

        this.props
            .dispatch(
                actions.definitions[method]({
                    ...this.endpoint,
                    data: param,
                })
            )
            .then((resp) => {
                loadings.submit = false;

                this.setState({
                    loadings,
                });

                Notification.success({
                    message: i18n.t("successSave", {
                        lng: this.props.currentLanguage,
                        type: i18n.t("settings", {
                            lng: this.props.currentLanguage,
                        }),
                    }),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 3,
                });

                this.props.dispatch(actions.auth.getAccount());

            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };


    render() {

        let { form, loadings } = this.state;

        return (

            <div className="form-container settings">

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='heading'><strong>{`Ayarlar`}</strong></div>
                }


                {
                    !loadings.data &&
                    <div className='form-box'>


                        <Row>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18} >
                                <div className='item-label'>
                                    Talep oluştururken beni ilgili kişi olarak otomatik ekle
                                </div>

                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                                <div className='item-switch'>
                                    <Switch checked={form.keepThePassengersEmptyWhileTripCreating} onChange={(e) => this.fetch("keepThePassengersEmptyWhileTripCreating", e)}></Switch>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18} >
                                <div className='item-label'>
                                    Araçiste GİZLİLİK POLİTİKASI ’nda belirtilen şekliyle kişisel verilerimin doğrudan veya dolaylı pazarlama faaliyetlerinin gerçekleştirilmesi amacıyla işlenmesini ve yukarıda belirtilen iletişim bilgilerime reklam, promosyon, vb. ticari elektronik ileti gönderilmesini, bilgilerimin bu amaçla kullanılmasını, saklanmasını ve ZER’in hizmet aldığı üçüncü kişilerle paylaşılmasını kabul ediyorum.
                                </div>

                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                                <div className='item-switch'>
                                    <Switch checked={form.isProtectionOfPersonelData} onChange={(e) => this.fetch("isProtectionOfPersonelData", e)}></Switch>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18} >
                                <div className='item-label'>
                                    E-Posta Bildirimlerini Gönder
                                </div>

                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                                <div className='item-switch'>
                                    <Switch checked={form.isNotificationEmail} onChange={(e) => this.fetch("isNotificationEmail", e)}></Switch>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18} >
                                <div className='item-label'>
                                    SMS Bildirimlerini Gönder
                                </div>

                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                                <div className='item-switch'>
                                    <Switch checked={form.isNotificationSms} onChange={(e) => this.fetch("isNotificationSms", e)}></Switch>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={18} sm={18} md={18} lg={18} xl={18} >
                                <div className='item-label'>
                                    Push Bildirimlerini Gönder
                                </div>

                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                                <div className='item-switch'>
                                    <Switch checked={form.isNotificationPush} onChange={(e) => this.fetch("isNotificationPush", e)}></Switch>
                                </div>
                            </Col>
                        </Row>

                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Settings);


// WEBPACK FOOTER //
// ./src/components/App/Views/Account/Settings.js